import { render } from "./Loader.vue?vue&type=template&id=62dc39a8"
const script = {}

import "./Loader.vue?vue&type=style&index=0&id=62dc39a8&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__